"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PersistenceService_1 = require("./PersistenceService");
/**
 * This feature can be used by creating a new file with something like:
 * ```
 * export const AsueeePersistenceService = new SimplePersistenceService<AsueeeModel>('your-application-key');
 * ```
 * There is also a more advanced version in {@linkcode PersistenceService}.
 */
var SimplePersistenceService = /** @class */ (function () {
    function SimplePersistenceService(key) {
        this.key = key;
        this.persistenceService = new PersistenceService_1.PersistenceService();
    }
    SimplePersistenceService.prototype.set = function (value) {
        this.persistenceService.set(this.key, value);
    };
    SimplePersistenceService.prototype.get = function (defaultValue) {
        if (defaultValue === void 0) { defaultValue = {}; }
        return this.persistenceService.get(this.key, defaultValue);
    };
    SimplePersistenceService.prototype.remove = function () {
        this.persistenceService.remove(this.key);
    };
    return SimplePersistenceService;
}());
exports.SimplePersistenceService = SimplePersistenceService;
//# sourceMappingURL=SimplePersistenceService.js.map